import { render, staticRenderFns } from "./TheResumenVenta.vue?vue&type=template&id=160e2622&scoped=true&"
import script from "./TheResumenVenta.vue?vue&type=script&lang=js&"
export * from "./TheResumenVenta.vue?vue&type=script&lang=js&"
import style0 from "./TheResumenVenta.vue?vue&type=style&index=0&id=160e2622&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e2622",
  null
  
)

export default component.exports